// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Admin pages
import AdminDashboard from "./Pages/Admin/AdminDashboard";
import AdminLogin from "./Pages/Admin/AdminLogin";
import AllBookingsPage from "./Pages/Admin/AllBookingsPage";

// Customer pages
import CustomerBookingPage from "./Pages/Customer/CustomerBookingPage";
import VehiclesPage from "./Pages/Customer/VehiclesPage";
import DayTripsPage from "./Pages/Customer/DayTripsPage";
import DayTripBookingPage from "./Pages/Customer/DayTripBookingPage";
import AirportTransfersPage from "./Pages/Customer/AirportTransfersPage";
import ToursBookingPage from "./Pages/Customer/ToursBookingPage";
import PrivacyPolicyPage from "./Pages/Customer/PrivacyPolicyPage";
import FeedbackPage from "./Pages/Customer/FeedbackPage";

function App() {
  return (
    <Routes>
      {/* Customer routes */}
      <Route path="/" element={<CustomerBookingPage />} />
      <Route path="/vehicles" element={<VehiclesPage />} />
      <Route path="/day-trips" element={<DayTripsPage />} />
      <Route path="/day-trip-booking" element={<DayTripBookingPage />} />
      <Route path="/airport-transfers" element={<AirportTransfersPage />} />
      <Route path="/tours-booking" element={<ToursBookingPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/feedback" element={<FeedbackPage />} />

      {/* Admin routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/bookings" element={<AllBookingsPage />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
